module.exports = __webpack_public_path__ + "static/media/slurpee.fb189555.gif";